module.exports = __webpack_public_path__ + "static/img/6.a1dc53b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/zh/6.png
// module id = t7/6
// module chunks = 0